import React, { useState } from 'react';

import HeaderDropdownListItem from 'components/shared/Header/HeaderDropdownListItem';
import {
  LabelCaretContainer,
  LabelHelptextWrapper,
  LabelWrapper,
  MenuItem,
  StyledHR,
} from 'components/shared/Header/stylesV2';
import Header from '.';
import {
  HamburgerListItem,
  HeaderButtonItem,
  HeaderLink,
  HeaderList,
  HeaderListItem,
  headerStyles,
} from 'components/shared/Header/PublicHeaderStyles';
import AnalyticsProvider from 'components/shared/analytics/AnalyticsProvider';
import Caret from 'components/ui/icons/Caret';
import JoinButton from 'components/shared/JoinButton';
import LoginButton from 'components/shared/LoginButton';
import { mediaSetQueries } from 'styleGuide';
import { navItems } from 'components/shared/Header/NavItems';
import publicTheme from 'publicTheme';
import styled from 'styled-components';
import { useMediaSet } from 'use-media-set';

const DropdownItemDescription = styled.div(
  ({ theme }) => `
  font-size: ${theme.fontSizes.sm};
  font-weight: 400;
  padding: 0.5rem 1rem;
  width: 120px;
  hover: none;
  text-align: left;
  color: #787b85;
`,
);

const MenuItemsContainer = styled.div`
  border-left: 1px solid #dadbdd;
`;

const PublicHeader = props => {
  const [selectedMenu, setSelectedMenu] = useState(null);

  const mediaStates = useMediaSet(mediaSetQueries);
  const hamburgerScreenSize = mediaStates.has('mobileOrLaptopM');

  // for hamburgerScreenSize: when children menu items are shown, selectedMenu is true
  const items = selectedMenu ? selectedMenu.children : navItems;

  // for !hamburgerScreenSize
  const dropdowns = navItems.slice(0, -1);
  const directLink = navItems.slice(-1).pop();

  const handleMenu = selectedItem => {
    if (selectedItem.href) {
      // Go to the URL
      window.location.href = selectedItem.href;
    } else {
      setSelectedMenu(selectedItem);
    }
  };

  return (
    <AnalyticsProvider>
      <Header
        data-testid="public-header"
        theme={publicTheme}
        css={headerStyles}
        onBack={() => setSelectedMenu(null)}
        onClose={() => setSelectedMenu(null)}
        headerText={selectedMenu ? selectedMenu.label : ''}
        {...props}
      >
        <HeaderList className="m-0">
          {!hamburgerScreenSize && (
            <>
              {dropdowns.map(parent => (
                <HeaderDropdownListItem
                  className="text-nowrap"
                  data-text={parent.label}
                  label={parent.label}
                  key={parent.label}
                >
                  <DropdownItemDescription className="text-wrap">
                    {parent.helptext}
                  </DropdownItemDescription>
                  <MenuItemsContainer>
                    {parent.children.map(child => (
                      <MenuItem
                        href={child.href}
                        target={child.target}
                        key={child.label}
                      >
                        {child.label}
                      </MenuItem>
                    ))}
                  </MenuItemsContainer>
                </HeaderDropdownListItem>
              ))}
              <HeaderListItem data-text={directLink.label}>
                <HeaderLink href={directLink.href} target={directLink.target}>
                  {directLink.label}
                </HeaderLink>
              </HeaderListItem>
            </>
          )}

          {/* Start: nested hamburger menu for mobile and desktop screens at 1305px or less */}
          {hamburgerScreenSize &&
            items.map(navItem => {
              return (
                <HamburgerListItem key={navItem.label}>
                  <LabelCaretContainer onClick={() => handleMenu(navItem)}>
                    <LabelHelptextWrapper>
                      <LabelWrapper>{navItem.label}</LabelWrapper>
                      <div className="helptext">{navItem.helptext}</div>
                    </LabelHelptextWrapper>
                    {navItem.children && (
                      <Caret
                        className="ml-2"
                        style={{ marginRight: '1.7rem' }}
                        width={18}
                      />
                    )}
                  </LabelCaretContainer>
                  <StyledHR />
                </HamburgerListItem>
              );
            })}
          {/* End: nested hamburger menu for mobile and desktop screens at 1305px or less */}

          {(!selectedMenu || !hamburgerScreenSize) && (
            <>
              <HeaderButtonItem
                className={!hamburgerScreenSize ? '' : 'mt-5'}
                data-analyticsid="homepage-navbar-login-btn"
              >
                <LoginButton data-id="header-login-component-btn" />
              </HeaderButtonItem>
              <HeaderButtonItem data-analyticsid="homepage-navbar-join-btn">
                <JoinButton data-id="header-join-component-btn" />
              </HeaderButtonItem>
            </>
          )}
        </HeaderList>
      </Header>
    </AnalyticsProvider>
  );
};

export default PublicHeader;
